<template>
  <div class="v-table-header">
    <div class="v-table-td-summary">
      摘要
    </div>
    <div class="v-table-td-subject">
      会计科目
    </div>
    <div class="v-table-td-debit">
      <div class="v-table-td-debit-text">
        借方金额
      </div>
      <v-table-uint/>
    </div>
    <div class="v-table-td-credit">
      <div class="v-table-td-credit-text">贷方金额</div>
      <v-table-uint/>
    </div>
  </div>
</template>
<script setup>
import VTableUint from "@components/VoucherTable/VTableUint.vue";
</script>
<style scoped lang="less">
.v-table {
  &-header {
    font-weight: bold;
    text-align: center;
    display: flex;
    height: 61px;
    border-bottom: @border;
    //固定表头新增
    border: @border;
    //position:fixed;
    //top:176px;
    //z-index:98;
    //width:960px;
    //background:#fff;
  }


  &-td {
    &-summary {
      width: 210px;
      line-height: 60px;
      border-right: @border;
    }

    &-subject {
      flex: 1;
      line-height: 60px;
      border-right: @border;
    }

    &-debit {
      width: 241px;
      border-right: @border;

      &-text {
        border-bottom: @border;
        line-height: 30px;
      }
    }

    &-credit {
      width: 241px;

      &-text {
        border-bottom: @border;
        line-height: 30px;
      }
    }
  }
}
.layui-layer-content .update-view .v-table-header{
  border: @border;
  position:fixed;
  top:180px;
  z-index:98;
  width:960px;
  background:#fff;
}
</style>
